import { Box, Stack, Typography, Tooltip } from "@mui/material";
import { grey, green, yellow } from "@mui/material/colors";

export const ProjectStatus = {
  BUILDING_SCENARIOS: "BUILDING_SCENARIOS",
  IN_PROGRESS: "IN_PROGRESS",
  TESTING: "TESTING",
  PRODUCTION: "PRODUCTION"
}

const stages = [
  ProjectStatus.BUILDING_SCENARIOS,
  ProjectStatus.IN_PROGRESS,
  ProjectStatus.TESTING,
  ProjectStatus.PRODUCTION
];

const stageLabels = {
  [ProjectStatus.BUILDING_SCENARIOS]: "Building Scenario",
  [ProjectStatus.IN_PROGRESS]: "In Progress",
  [ProjectStatus.TESTING]: "Testing",
  [ProjectStatus.PRODUCTION]: "Production"
};

export const ProjectStageProgress = ({ status }) => {
  const currentIndex = stages.indexOf(status);

  return (
    <Box>
      <Typography fontSize={{xs: "0.75em", md: "0.9em"}} color="text.secondary">Stage</Typography>
      <Typography fontWeight={600} mb={{xs: 0.5, md: 1}} fontSize={{xs: "0.95em", md: "1.2em"}}>
        {stageLabels[status] || "Unknown"}
      </Typography>

      <Stack direction="row" gap={{xs: 0.5, md: 1}}>
        {stages.map((stage, index) => {
          const bgColor =
            index < currentIndex
              ? green[500]
              : index === currentIndex
                ? yellow[700]
                : grey[300];

          return (
            <Tooltip title={stageLabels[stage]} key={stage}>
              <Box
                sx={{
                  width: 20,
                  height: 6,
                  borderRadius: 2,
                  backgroundColor: bgColor,
                  transition: "background-color 0.3s ease"
                }}
              />
            </Tooltip>
          );
        })}
      </Stack>
    </Box>
  );
};
